"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPriceDirection = void 0;
var _constants = require("./constants");
var getPriceDirection = exports.getPriceDirection = function getPriceDirection(_ref) {
  var oldPrice = _ref.oldPrice,
    newPrice = _ref.newPrice;
  var priceDirection = newPrice > oldPrice ? _constants.DIRECTION.increased : _constants.DIRECTION.decreased;
  var isDecreased = priceDirection === _constants.DIRECTION.decreased;
  var isIncreased = priceDirection === _constants.DIRECTION.increased;
  return {
    priceDirection: priceDirection,
    isDecreased: isDecreased,
    isIncreased: isIncreased
  };
};